var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('payment-method-modal'),expression:"'payment-method-modal'"}],attrs:{"disabled":_vm.model.id ? true : false}},[_vm._v(" Indicar Metodos de pago ")])
}
var staticRenderFns = []

export { render, staticRenderFns }